interface ProductTabButtonProps {
    label: string;
    tabKey: string;
    activeTab: string;
    onClick: (key: string) => void;
}

// This component is used to render a button for each tab in the product details page.
// Se usa en DetalleProducto.tsx y en TireSpecsCard.tsx

const ProductTabButton = ({ label, tabKey, activeTab, onClick }: ProductTabButtonProps) => {

    return (
        <button
            className={`w-full sm:flex-1 py-3 px-6 sm:py-2 sm:px-4 text-lg sm:text-base h-[73.56px] transition-all duration-300 
                        border-b-4 border-light01 border-l border-r border-l-light01 border-r-light01 
                        ${activeTab === tabKey ? "bg-light01 border-yellow02 font-bold" : "bg-white border-gray-300 hover:bg-gray-100"}`}
            onClick={() => onClick(tabKey)}
        >
            {label}
        </button>
    );
};


export default ProductTabButton;